"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemaVisita = exports.yupVisita = void 0;
const yup = __importStar(require("yup"));
const enums_1 = require("../enums");
const utils_1 = require("../utils");
const estado_1 = require("./estado");
exports.yupVisita = yup.object({
    nome: yup
        .string()
        .required('Nome do aluno é obrigatório')
        .label('Nome do aluno')
        .max(65, 'Máximo de 65 caracteres.')
        .default(''),
    sexo: yup.mixed().oneOf(Object.values(enums_1.ESexo)).required().label('Sexo').default(enums_1.ESexo.Feminino),
    dataVisita: (0, utils_1.sge2Date)().nullable().label('Data da Visita').default(null),
    paiNome: yup.string().max(65, 'Máximo de 65 caracteres.').default('').label('Nome do pai'),
    maeNome: yup.string().max(65, 'Máximo de 65 caracteres.').default('').label('Nome da Mãe'),
    email: yup
        .string()
        .max(65, 'Máximo de 65 caracteres.')
        .email('Formato de e-mail inválido.')
        .default('')
        .label('E-mail'),
    dataNasc: (0, utils_1.sge2Date)().nullable().label('Data de Nascimento').default(null),
    endereco: yup.string().default('').max(65, 'Máximo de 65 caracteres.').label('Endereço'),
    complemento: yup.string().default('').max(65, 'Máximo de 65 caracteres.').label('Complemento'),
    bairro: yup.string().default('').max(100, 'Máximo de 100 caracteres.').label('Bairro'),
    cep: yup.string().default('').max(10, 'Máximo de 10 caracteres.').label('CEP'),
    cidade: yup.string().default('').max(75, 'Máximo de 75 caracteres.').label('Cidade'),
    uf: yup
        .string()
        .oneOf(estado_1.estado.map((m) => m.sigla))
        .default('')
        .label('Estado'),
    foneResidencial: yup.string().default('').max(50, 'Máximo de 50 caracteres.').label('Telefone Residencial'),
    foneComercial: yup.string().default('').max(50, 'Máximo de 50 caracteres.').label('Telefone Comercial'),
    religiao: yup.string().default('').max(30, 'Máximo de 50 caracteres.').label('Religião'),
    turmaInteresse: yup.string().default('').max(50, 'Máximo de 50 caracteres.').label('Turma com interesse'),
    sabendo: yup.string().default('').max(50, 'Máximo de 50 caracteres.').label('Como ficou sabendo'),
    retorno: yup.string().default('').max(65, 'Máximo de 65 caracteres.').label('Retorno'),
    foneCelular: yup.string().default('').max(50, 'Máximo de 50 caracteres.').label('Celular'),
    cpf: yup.string().default('').label('CPF').max(15, 'Máximo de 15 caracteres.'),
    cpfComRestricao: yup.bool().required().label('Com restrição').default(false),
    soubePorIndicacao: yup.bool().required().label('Indicação').default(false),
    soubePorOutdoor: yup.bool().required().label('Outdoors').default(false),
    soubePorRadio: yup.bool().required().label('Radio').default(false),
    soubePanfleto: yup.bool().required().label('Panfletos').default(false),
    soubePorTvInternet: yup.bool().required().label('Tv e ou internet').default(false),
    soubePorOutros: yup.bool().required().label('Outros').default(false),
    colegioAtual: yup.string().default('').max(100, 'Máximo de 100 caracteres.').label('Instituição de ensino atual'),
    jaReprovou: yup.bool().required().label('Já reprovou?').default(false),
    acompanhamentoProfissional: yup.bool().required().label('Faz acompanhamento com algum profissional').default(false),
    acompanhamentoFonoaudiologo: yup.bool().required().label('Acompanhamento com fonoaudiólogo').default(false),
    acompanhamentoPsicopedagogo: yup.bool().required().label('Acompanhamento com Pscicopedagogo').default(false),
    acompanhamentoNeurologista: yup.bool().required().label('Acompanhamento com Neurologista').default(false),
    acompanhamentoFisioterapia: yup.bool().required().label('Acompanhamento com Fisioterapeuta').default(false),
    matriculado: yup.bool().required().label('Matriculado').default(false),
    responsavelNome: yup.string().default('').max(65, 'Máximo de 65 caracteres.').label('Nome do Responsável'),
    responsavelEmail: yup
        .string()
        .max(65, 'Máximo de 65 caracteres.')
        .email('Formato de e-mail inválido.')
        .default('')
        .label('E-mail Responsável'),
    responsavelCpf: yup.string().max(15, 'Máximo de 15 caracteres.').default('').label('CPF do responsável'),
    paiCpf: yup.string().default('').label('CPF do Pai').max(15, 'Máximo de 15 caracteres.'),
    maeCpf: yup.string().default('').label('CPF da Mãe').max(15, 'Máximo de 15 caracteres.'),
    tomaMedicamento: yup.bool().required().label('Toma algum medicamento').default(false),
    compareceu: yup.bool().required().label('Compareceu').default(false),
    dataMatricula: (0, utils_1.sge2Date)().nullable().label('Data da Matrícula').default(null),
    carteirinha: yup.string().default('').max(15, 'Máximo de 15 caracteres.').label('Cartão de identificação'),
    idEmpresa: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .positive()
        .integer()
        .nullable()
        .default(null)
        .label('Empresa'),
    idFuncionario: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .positive()
        .integer()
        .nullable()
        .default(null)
        .label('Funcionário Responsável'),
    motivo: yup
        .mixed()
        .oneOf(Object.values(enums_1.EMotivoNaoEfetivo))
        .label('Motivo da não efetivação')
        .default(enums_1.EMotivoNaoEfetivo.Nenhum),
});
exports.schemaVisita = exports.yupVisita.shape({});
